import * as _ from 'lodash';
import { fromJS } from 'immutable';

import * as actions from '../actions/settlements';
import { fetchingState } from '@constants';

const initialState = fromJS({
  settlements: {
    data: [],
    state: null,
    stateUpdate: null,
  },
});

const SettlementsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.INSERT_SETTLEMENT_SUCCESS: {
      return state.setIn(['settlements', 'state'], fetchingState.LOADED);
    }
    case actions.FETCH_SETTLEMENTS_SUCCESS: {
      return state
        .setIn(
          ['settlements', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        )
        .setIn(['settlements', 'state'], fetchingState.LOADED);
    }

    case actions.INSERT_SETTLEMENT_START: {
      return state.setIn(['settlements', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_SETTLEMENTS_START: {
      return state.setIn(['settlements', 'state'], fetchingState.FETCHING);
    }

    case actions.INSERT_SETTLEMENT_ERROR: {
      return state.setIn(['settlements', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_SETTLEMENTS_ERROR: {
      return state.setIn(['settlements', 'state'], fetchingState.ERROR);
    }

    case actions.UPDATE_SETTLEMENT_START: {
      return state.set('stateUpdate', fetchingState.FETCHING);
    }
    case actions.UPDATE_SETTLEMENT_SUCCESS: {
      const { settlementID } = action.payload;

      return state.set('stateUpdate', fetchingState.LOADED).setIn(
        ['settlements', 'data'],
        fromJS(
          state
            .getIn(['settlements', 'data'])
            .toJS()
            .map(settlement =>
              settlement.settlementID !== settlementID
                ? settlement
                : action.data.results[0],
            ),
        ),
      );
    }
    case actions.UPDATE_SETTLEMENT_TAGS_SUCCESS: {
      const { settlementID } = action.payload;

      return state.set('stateUpdate', fetchingState.LOADED).setIn(
        ['settlements', 'data'],
        fromJS(
          state
            .getIn(['settlements', 'data'])
            .toJS()
            .map(settlement =>
              settlement.settlementID !== settlementID
                ? settlement
                : {
                    ...settlement,
                    tags: _.get(action, 'data.resutls', []),
                  },
            ),
        ),
      );
    }
    case actions.UPDATE_SETTLEMENT_ERROR: {
      return state.set('stateUpdate', fetchingState.ERROR);
    }

    case actions.DELETE_SETTLEMENT_START: {
      return state.setIn(
        ['settlements', 'stateUpdate'],
        fetchingState.FETCHING,
      );
    }
    case actions.DELETE_SETTLEMENT_SUCCESS: {
      const { settlementID } = action.payload;

      return state.set('stateUpdate', fetchingState.LOADED).setIn(
        ['settlements', 'data'],
        fromJS(
          state
            .getIn(['settlements', 'data'])
            .toJS()
            .filter(settlement => settlement.settlementID !== settlementID),
        ),
      );
    }
    case actions.DELETE_SETTLEMENT_ERROR: {
      return state.setIn(['settlements', 'stateUpdate'], fetchingState.ERROR);
    }

    default: {
      return state;
    }
  }
};

export default SettlementsReducer;
